var render = function render(){var _vm=this,_c=_vm._self._c;return _c('code',{staticClass:"block_code",on:{"click":_vm.clickAnywhere}},[_c('span',{ref:"my_code_block"},[_vm._t("default")],2),_c('v-icon',{staticStyle:{"position":"absolute","right":"3px","bottom":"3px"},on:{"click":_vm.onCopy}},[_vm._v(" mdi-content-copy ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }